import { UntypedFormControl, ValidationErrors } from "@angular/forms";

export function ipValidator(control: UntypedFormControl): ValidationErrors | undefined {
  if (!validIP(control.value)) {
    return {
      invalidIP: true,
    };
  }

  function validIP(value: string) {
    const pattern =
      "^([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])$";
    return new RegExp(pattern).test(value);
  }
}
